// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__8AoqD","tab":"styles_tab__WjqMe","label":"styles_label__D53iN"};